import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-161">
      <div className="max-w-4xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-163">
          <blockquote className="text-lg md:text-2xl text-white leading-relaxed italic mb-6 md:mb-8" data-id="element-164">
            "Stworzyliśmy ten system dla polskich trenerów piłki nożnej którzy
            ciężko pracują ale jeszcze nie widzą wyników których pragną.
            <br data-id="element-165" />
            <br data-id="element-166" />
            Żadnej teorii. Żadnych drogich konsultantów. Tylko narzędzia które
            naprawdę działają — żebyś mógł trenować piłkę nożną jak prawdziwy
            profesjonalista."
          </blockquote>
          <p className="text-gold-accent font-bold text-lg md:text-xl" data-id="element-167">
            — Zespół FUTBOL GOTOWY
          </p>
        </motion.div>
      </div>
    </section>;
}